<template>
  <div class="real-container">
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-row"
      >
        <h2 class="content-tit">
            {{pageTitle}}
        </h2>
        <div class="data-control">
          <button type="button" class="button search-btn" @click="searchLogInfo()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
            검색
          </button>
          <button type="button" class="button data-excel" @click="exportExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
            엑셀다운
          </button>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col client-ui"
      >
      <label class="default-tit input-tit text-center" for="occurrence-start">
          등록일 
        </label>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateFromMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceFromMain"
                  prepend-icon="mdi-calendar"      
                  label="From"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceFromMain"
                locale="ko"
                :max="occurrenceToMain"
                @input="dateFromMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateToMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceToMain"
                  prepend-icon="mdi-calendar"      
                  label="To"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceToMain"
                locale="ko"
                :min="occurrenceFromMain"
                :max="maxToDate"
                @input="dateToMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-col>
      <!-- <v-col
        cols="12"
        md="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="menu-status">
          메뉴
        </label>
        <multiselect
          id="menu-status"
          v-model="menuPathVal"
          :options="menuPathOption"
          :multiple="true"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="메뉴를 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">메뉴를 선택해주세요.</span></multiselect>
      </v-col> -->
    </v-row>
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="ui-col d-flex flex-column"
      >
          <h3 class="grid-tit">{{cardTitle}}</h3>
          <!--<div id="master-left-data" class="real-grid"></div>-->
          <div id="master-grid" class="real-grid"></div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import JSZip from 'jszip'
import { GridView, LocalDataProvider } from 'realgrid'
import { logInfoFields, logInfoColumns } from './gridData/LogSearch.js'
import { mapGetters } from 'vuex'
let mstGridView = GridView
let mstDataProvider = LocalDataProvider


export default {
  name: 'LogSearch',
  data() {
    return {
      pageTitle:'계정별 로그 조회',
      cardTitle: '로그상세 내역',
      dateToMain: false,
      occurrenceToMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFromMain: false,
      occurrenceFromMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      maxToDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      logInfoList: [
      ],
      ownerKey: '',
      userId: '',
      //메뉴
      // menuPathOption: [
      // ],
      // menuPathVal: '',
    }
  },
  created() {
    let info = JSON.parse(sessionStorage.getItem('userInfo'))
    var selectOwner = sessionStorage.getItem('selectOwner')
    this.ownerKey = selectOwner
    this.userId = info[0].userId
    //메뉴
    // if(this.codeInfoObj === '' || this.codeInfoObj === null){
    //   setTimeout(() => {
    //     this.initSettings()
    //   }, 1000)
    // }else{
    //   this.initSettings()
    // }
  },
  methods: {
    //메뉴
    // initSettings() {
    //   this.menuPathOption = [
    //     {
    //       name: '전체',
    //       value: ''
    //     }
    //   ]
    //   for(var i = 0; i < this.codeInfoObj.length; i++) {
    //     if(this.codeInfoObj[i].mstCode === 'MECD') {
    //       var menuItem = {'name': this.codeInfoObj[i].menuPath, 'value' : this.codeInfoObj[i].menuPathNm}
    //       this.menuPathOption.push(menuItem)
    //     }
    //   }

    // },
    searchLogInfo() {
      let fromYmd = this.occurrenceFromMain.replace(/-/g, '')
      let toYmd = this.occurrenceToMain.replace(/-/g, '')
      // 검색기간 31일 이하 
      let diffDay = (new Date(this.occurrenceToMain).getTime() - new Date(this.occurrenceFromMain).getTime()) / (1000 * 3600 * 24)
      if(diffDay > 31){
        this.$swal({
            title: '검색기간은 31을 넘길 수 없습니다.'
        })
        return
      }
      this.$loading.show({delay:0})
      this.$store.dispatch('apiLogInfoData', {'fromDt':fromYmd, 'toDt':toYmd, 'ownerKey': this.ownerKey}).then(() => {       
        // console.log(this.logInfoData);
        if(this.logInfoData.code === 'OK') { 
            this.logInfoList = []
            this.logInfoList = this.logInfoData.logInfo
            mstDataProvider.setRows(this.logInfoList)
        } else {
          this.$swal({
            title: this.logInfoData.message
          })
          mstDataProvider.clearRows()
        }
      }).catch((error) => {
        this.$swal({
            title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300)
      })
    },
    exportExcel(){    
      if(this.fromYmd === '' || this.toYmd === ''){
        this.$swal({
            title: '날짜를 선택해 주세요.'
        })
        return
      }
      
      mstGridView.exportGrid({
          type: "excel",
          target: "local",
          fileName: "Log.xlsx",
          showProgress: true,
          progressMessage: "엑셀 Export중입니다.",
          indicator: 'hidden',
          header: true,
          compatibility: '2010',
          linear: true,
          separateRows: true,
          allColumns:true,
          lookupDisplay:true
      })
    }   
  },
  mounted() {
    window.JSZip = window.JSZip || JSZip

    mstDataProvider = new LocalDataProvider(true)
    mstGridView = new GridView('master-grid')
    mstGridView.setDataSource(mstDataProvider)
    mstGridView.setCheckBar({
      visible: false
    })
    mstGridView.setStateBar({
      visible: false
    })
    mstGridView.setPasteOptions({
      enabled: false
    })
    mstGridView.setEditOptions({
      editable: false,
      updatable: false
    }),
    mstDataProvider.setFields(logInfoFields)
    mstGridView.setColumns(logInfoColumns)
    
    mstGridView.displayOptions.selectionStyle = "singleRow"
    mstGridView.displayOptions.fitStyle = "even"
  },
  computed: {
    ...mapGetters({
      logInfoData: 'getLogInfoData',
      //codeInfoObj: 'getCodeData',
    })
  }
}
</script>
